import { ActionContext } from 'vuex'
import apiAdminMesureType from '@/api/admin/mesureType'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IMesureTypeState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbMesureType } from '@/models/alodb/AloDbMesureType';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class MesureTypeAction {
   
  public [types.MESURETYPE_REQUEST](context: ActionContext<IMesureTypeState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.MESURETYPE_REQUEST)
        apiAdminMesureType
          .getMesureTypes()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const mesureTypeArray = resp.data.data as AloBaseArray<AloDbMesureType>
              context.commit(types.MESURETYPE_SUCCESS, mesureTypeArray.items)
              resolve(mesureTypeArray.items)
            } else {
              context.commit(types.MESURETYPE_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.MESURETYPE_ERROR)
            reject()
          })
      })
  }

  public [types.MESURETYPE_ENSURE_LIST](context: ActionContext<IMesureTypeState, IRootState>) {
    if(context.state.mesureTypes.length == 0) {
        return context.dispatch(types.MESURETYPE_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.mesureTypes)            
        })
    }    
  }

  public [types.MESURETYPE_SELECT_DETAIL](context: ActionContext<IMesureTypeState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const mesureType = context.getters.mesureTypesById[itemId] as AloDbMesureType      
      if(mesureType) {        
        if(mesureType.detailLoaded) {
          context.commit(types.MESURETYPE_SELECT_DETAIL,mesureType)
          resolve(mesureType)
        }
        else{
          context.dispatch(types.MESURETYPE_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.MESURETYPE_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newMesureType = new AloDbMesureType()
        context.commit(types.MESURETYPE_SELECT_DETAIL,newMesureType)
        resolve(newMesureType)
      }
    })
  }

  public [types.MESURETYPE_SELECT_DETAIL_REQUEST](context: ActionContext<IMesureTypeState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.MESURETYPE_SELECT_DETAIL_REQUEST, itemId)
        apiAdminMesureType
          .getMesureType(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const mesureType = resp.data.data as AloDbMesureType
              context.commit(types.MESURETYPE_SELECT_DETAIL_SUCCESS, mesureType)
              context.commit(types.MESURETYPE_SELECT_DETAIL,mesureType)
              resolve(mesureType)
            } else {
              context.commit(types.MESURETYPE_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.MESURETYPE_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.MESURETYPE_SAVE_REQUEST](context: ActionContext<IMesureTypeState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmMesureType.id
        context.commit(types.MESURETYPE_SAVE_REQUEST,context.state.modifiedAdmMesureType.MET_LIBELLE)
        apiAdminMesureType
          .saveMesureType(context.state.modifiedAdmMesureType)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const mesureType = resp.data.data as AloDbMesureType            
              context.commit(types.MESURETYPE_SELECT_DETAIL_SUCCESS, mesureType)
              context.commit(types.MESURETYPE_SELECT_DETAIL,mesureType)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:mesureType.MET_LIBELLE}))
              if(tryRedirect && router.app.$route.name === 'NewMesureType') router.push({name:'EditMesureType',params:{mesureTypeid:mesureType.id!.toString()}})
              resolve(mesureType)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.MESURETYPE_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.MESURETYPE_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.MESURETYPE_UPDATE_MODIFIED_ADM](context: ActionContext<IMesureTypeState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MESURETYPE_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmMesureType)
    })
  }
  
  public [types.MESURETYPE_CANCEL_MODIFIED_ADM](context: ActionContext<IMesureTypeState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MESURETYPE_SELECT_DETAIL,context.state.originalAdmMesureType)
      resolve(context.state.modifiedAdmMesureType)
    })
  }

  public [types.MESURETYPE_UPDATE_FILTER_ADM](context: ActionContext<IMesureTypeState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MESURETYPE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
  
  
}

export default util.classToObject(MesureTypeAction)